<!-- MOLECULE: OtpResultsActions.vue -->

<script setup lang="ts">
//
// Imports
//

import AppBarActionButton from "./AppBarActionButton.vue";

//
// Composables
//

const { t } = useI18n();
const { triggerRefresh } = useOtpVisit();
const { showSnackbar } = useSnackbar();

// Share the same "otp-results" key as the results page — useState returns the
// same reactive ref, so loading reflects exactly what the page is doing.
const { loading, isPaymentRequired, currentVisitResults } = useVisits("otp-results");

//
// Computed
//

// A silent refresh keeps existing content visible but the button should still
// indicate activity so the user knows something is happening.
const isRefreshing = computed(() => loading.value);

/** Email / PDF actions are only available after the patient has paid and results exist. */
const areActionsDisabled = computed(
  () =>
    isPaymentRequired.value ||
    !currentVisitResults.value ||
    currentVisitResults.value.departmentResults.length === 0,
);

//
// Methods
//

/** Placeholder handler — shows an error snackbar until the feature is wired. */
const handleNotImplemented = () => {
  showSnackbar(t("components.common.snackbar.actions.featureNotImplemented"), {
    color: "error",
    icon: "mdi-hammer-wrench",
  });
};
</script>

<template>
  <app-bar-action-button
    icon="mdi-refresh"
    :tooltip-text="t('pages.otp-patient.results.refresh.tooltip')"
    :loading="isRefreshing"
    :disabled="isRefreshing"
    @click="triggerRefresh"
  />
  <app-bar-action-button
    icon="mdi-email-outline"
    :tooltip-text="t('pages.otp-patient.results.email.tooltip')"
    :disabled="areActionsDisabled"
    @click="handleNotImplemented"
  />
  <app-bar-action-button
    icon="mdi-file-pdf-box"
    :tooltip-text="t('pages.otp-patient.results.pdf.tooltip')"
    :disabled="areActionsDisabled"
    @click="handleNotImplemented"
  />
</template>
